import { getKPIRequest } from "@/api/getKPIRequest.ts"
import type { KPIGroupRequest } from "@/types/kpiTypes.ts"

import type { MonthlyDisplayData } from "../types/monthlyDisplayTypes.ts"

export const getMonthlyData = async (): Promise<MonthlyDisplayData> => {
  const kpiRequest: KPIGroupRequest = {
    returnSize: 1,
    aggType: "Monthly",
    asOf: new Date(),
    kpis: [
      {
        $type: "basic",
        id: 10,
        location: 3,
        typeId: 1,
        aggFunction: "Sum",
      },
      {
        $type: "basic",
        id: 12,
        location: 3,
        typeId: 1,
        aggFunction: "Sum",
      },
      {
        $type: "basic",
        id: 11,
        location: 3,
        typeId: 1,
        aggFunction: "Sum",
      },
      {
        $type: "calc",
        name: "Time per Load",
        unit: "Hours",
        preAggregate: true,
        expression: "[340]/[11]",
        typeId: 1,
        aggFunction: "Average",
      },
    ],
  }
  const data = await getKPIRequest(kpiRequest)
  return {
    manure: data[0].values ? data[0].values[0].value : 0,
    uf: data[1].values ? data[1].values[0].value : 0,
    loads: data[2].values ? data[2].values[0].value : 0,
    timePerLoad: data[3].values ? data[3].values[0].value : 0,
  }
}
